import { render, staticRenderFns } from "./itensPregao.vue?vue&type=template&id=4ce5521c"
import script from "./itensPregao.vue?vue&type=script&lang=js"
export * from "./itensPregao.vue?vue&type=script&lang=js"
import style0 from "./itensPregao.vue?vue&type=style&index=0&id=4ce5521c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports